import { Pipe, PipeTransform } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';

function format(value: string | number): string {
  if (typeof value === 'number') {
    value = String(value);
  }

  if (value.indexOf('.') + 1) {
    const price = value.split('.');

    if (price[1] === '00' || price[1] === '0') {
      return price[0];
    } else {
      if (price[1].length === 1) {
        value += '0';
      }

      return value.replace('.', ',');
    }
  }

  return value;
}

@Pipe({name: 'priceFormat'})
export class PriceFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    return format(value);
  }
}

@Pipe({name: 'decoratePrice'})
export class DecoratePricePipe implements PipeTransform {
  constructor(
    private commonInfoService: CommonInfoService
  ) {
  }

  transform(value: string | number): string {
    return format(value) + ' ' + this.commonInfoService.priceEnding;
  }
}
